import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_TEAM_UNAVAILABILITY,
  ADD_TEAM_UNAVAILABILITY,
  UPDATE_TEAM_UNAVAILABILITY,
  DELETE_TEAM_UNAVAILABILITY,
} from './actionTypes'
import {
  getTeamUnavailabilitySuccess,
  getTeamUnavailabilityFail,
  addTeamUnavailabilitySuccess,
  addTeamUnavailabilityFail,
  updateTeamUnavailabilitySuccess,
  updateTeamUnavailabilityFail,
  deleteTeamUnavailabilitySuccess,
  deleteTeamUnavailabilityFail,
  setTeamUnavailabilityFieldErrors,
  getTeamUnavailability,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchTeamUnavailabilityApi = (id) => axiosInstance.get('', { params: { sp: "usp_GetTeamUnavailabilityByTeamId", TeamId: id } })
const addTeamUnavailabilityApi = (teamUnavailability) => axiosInstance.post('', teamUnavailability)
const updateTeamUnavailabilityApi = (teamUnavailability) => axiosInstance.post('', teamUnavailability)
const deleteTeamUnavailabilityApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteTeamUnavailability', unavailabilityId: id })

// Sagas
function* getTeamUnavailabilitySaga(action) {
  try {
    const { data } = yield call(fetchTeamUnavailabilityApi, action.payload)
    yield put(getTeamUnavailabilitySuccess(data))
  } catch (error) {
    yield put(getTeamUnavailabilityFail(error.response?.data || error.message))
  }
}

function* addTeamUnavailabilitySaga(action) {
  try {
    const { data } = yield call(addTeamUnavailabilityApi, action.payload)
    yield put(addTeamUnavailabilitySuccess(data))
    toast.success('Team Unavailability added successfully!')
    yield put(getTeamUnavailability(action?.payload?.teamId))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setTeamUnavailabilityFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addTeamUnavailabilityFail(error.response?.data || error.message))
    }
  }
}

function* updateTeamUnavailabilitySaga(action) {
  try {
    const { data } = yield call(updateTeamUnavailabilityApi, action.payload)
    yield put(updateTeamUnavailabilitySuccess(data))
    toast.success('Team Unavailability updated successfully!')
    yield put(getTeamUnavailability(action?.payload?.teamId))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setTeamUnavailabilityFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateTeamUnavailabilityFail(error.response?.data || error.message))
    }
  }
}

function* deleteTeamUnavailabilitySaga(action) {
  try {
    yield call(deleteTeamUnavailabilityApi, action.payload?.id)
    yield put(deleteTeamUnavailabilitySuccess(action.payload))
    toast.success('Team Unavailability deleted successfully!')
    yield put(getTeamUnavailability(action?.payload?.teamId))
  } catch (error) {
    yield put(deleteTeamUnavailabilityFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* teamUnavailabilitySaga() {
  yield takeEvery(GET_TEAM_UNAVAILABILITY, getTeamUnavailabilitySaga)
  yield takeEvery(ADD_TEAM_UNAVAILABILITY, addTeamUnavailabilitySaga)
  yield takeEvery(UPDATE_TEAM_UNAVAILABILITY, updateTeamUnavailabilitySaga)
  yield takeEvery(DELETE_TEAM_UNAVAILABILITY, deleteTeamUnavailabilitySaga)
}

export default teamUnavailabilitySaga
